export default "__VITE_ASSET__DTQ_6ktr__"